import { render, staticRenderFns } from "./ownerQuit.vue?vue&type=template&id=06b15e6c&scoped=true&"
import script from "./ownerQuit.vue?vue&type=script&lang=js&"
export * from "./ownerQuit.vue?vue&type=script&lang=js&"
import style0 from "./ownerQuit.vue?vue&type=style&index=0&id=06b15e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b15e6c",
  null
  
)

export default component.exports